import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { BreadcrumbsService } from '../../services/breadcrumbs.service';
import { Platform } from '@angular/cdk/platform';
import { MenuItem, MessageService } from 'primeng/api';

import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MenuModule } from 'primeng/menu';
import { Router, RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { VehicleTypeService } from '../../services/vehicle-type.service';
import { SelectedModificationService } from '../../services/selected-modification.service';
@Component({
  selector: 'app-breadcrumbs',
  standalone: true,
  imports: [RouterLink, ToastModule, MenuModule, ButtonModule, RippleModule],
  providers: [MessageService],
  templateUrl: './breadcrumbs.component.html',
  styleUrl: './breadcrumbs.component.scss',
})
export class BreadcrumbsComponent implements OnInit, AfterViewInit {
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event): void {
    if (this.platform.isBrowser) {
      this.checkBreadcrumbWidth();
    }
  }

  @ViewChild('breadcrumbsContainer', { static: true })
  breadcrumbsContainer!: ElementRef;
  @ViewChild('breadcrumbsWrapper', { static: true })
  breadcrumbsWrapper!: ElementRef;

  public breadcrumbMenuItems: MenuItem[] | any;
  public removedElements: HTMLElement[] = [];
  public breadcrumbsEnabled!: boolean;

  public breadcrumbsRemoved: boolean = false;
  constructor(
    public breadcrumbsService: BreadcrumbsService,
    private platform: Platform,
    private _location: Location,
    private router: Router,
    public vehicleTypeService: VehicleTypeService,
    public selectedModificationService: SelectedModificationService
  ) {}

  ngOnInit(): void {
    this.breadcrumbMenuItems = [
      {
        label: 'Navigate',
        items: [...(this.breadcrumbsService.breadcrumbs as any)],
      },
    ];
  }

  ngAfterViewInit(): void {
    this.checkBreadcrumbWidth();
  }

  public goBack() {
    const navigationState: any = this._location.getState();
    if (navigationState.navigationId > 1) {
      this._location.back();
    } else {
      if (this.platform.isBrowser) {
        window.history.back();
      }
    }
  }

  private checkBreadcrumbWidth(): void {
    if (this.platform.isBrowser) {
      const elementOffsetWidth: number =
        this.breadcrumbsWrapper?.nativeElement.offsetWidth;
      const availableScreenWidth: number =
        this.breadcrumbsContainer?.nativeElement.offsetWidth;
      if (elementOffsetWidth > availableScreenWidth) {
        const breadcrumbsWrapper = this.breadcrumbsWrapper?.nativeElement;
        const anchorElements = breadcrumbsWrapper.querySelectorAll('a');
        if (anchorElements.length > 2) {
          // Remove the second anchor element
          const removedElement = anchorElements[2] as HTMLElement;
          this.removedElements.push(removedElement);

          breadcrumbsWrapper.removeChild(removedElement);
          this.breadcrumbsRemoved = true;
        }
        requestAnimationFrame(() => {
          this.checkBreadcrumbWidth();
        });
      } else if (
        elementOffsetWidth < availableScreenWidth &&
        this.removedElements.length > 0
      ) {
      } else {
        // Add a condition to break the loop when no further adjustments are needed
      }
    }
  }
}
